// prefix.js
import { defineStore } from 'pinia'
import axios from 'axios'

export const usePrefixStore = defineStore('prefix', {
    state: () => ({
        allPrefix: [],
        prefixList: []
    }),
    actions: {
        async getAllPrefix(filter) {
            try {
                const response = await axios.get('/prefixes', filter)
                // console.log(response);
                if (response.status === 200) {
                    this.allPrefix = response.data.data
                }
                return response.data.data;
            } catch (error) {
                console.error('error:', error)
                throw error
            }
        },
    }
})
